
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'NotFoundComponent',
  data() {
    return {
      domain: config.DOMAIN,
      logoUrl: config.BASE_URL + '/img/logo.svg',
    };
  },
});
